import { Component, Input, Inject, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Log } from '../../interfaces/logs.interface';

@Component({
  selector: 'app-logs-display',
  standalone: false,
  templateUrl: './logs-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./logs-display.component.scss']
})
export class LogsDisplayComponent {
  @Input() logs: Log[] = [];

  // Mapping of HTTP methods to user-friendly Polish descriptions
  actionMap: { [key: string]: string } = {
    'POST': 'Nowe dane',
    'PUT': 'Aktualizacja danych',
    'PATCH': 'Aktualizacja cząściowa',
    'DELETE': 'Skasowano dane',
    'GET': 'Pobranie danych'
  };

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<LogsDisplayComponent>
  ) {
    if (data && data.logs) {
      this.logs = data.logs;
    }
  }

  getActionLabel(action: string): string {
    return this.actionMap[action] || action;
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}

